import { FeatureFlags } from "@utils/FeatureFlags/generated-flags";
import { useFlags } from "launchdarkly-react-client-sdk";

const REPORT_PART_REGENERATION_FLAG = "report-part-regeneration" satisfies keyof FeatureFlags;

export const useCanRegenerateReportParts = (): boolean => {
  const flags = useFlags<FeatureFlags>();
  return !!flags[REPORT_PART_REGENERATION_FLAG];
};
